export default __webpack_public_path__ + "static/media/icon-facebook-link.81c0abf9bbee3625f12edab6d5a100d3.svg";